export {default as InfoPribadiAlamat} from "./info-pribadi-alamat"
export {default as InfoAkunPengiriman} from "./info-akun-pengiriman"
export {default as AvatarChange} from "./avatar"